import { TSelectOption } from '@interfaces/components/componentTypes';

export const formatDefaultSelectOption = (option?: TSelectOption) => {
	if (!option) {
		return;
	}

	return {
		...option,
		value: option.name,
		label: option.title,
	};
};
